import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ICU from 'i18next-icu';

import { IS_EDITOR_MODE } from 'config/envVariable';
import { langTypes } from 'config/gameLangOptions';
import clientTranslation from './lang-client.json';
import editorTranslation from './lang-editor.json';

const resources = IS_EDITOR_MODE ? editorTranslation : clientTranslation;
const initLang = navigator.language || langTypes.EN_US;

i18n.use(ICU)
    .use(initReactI18next) // set this i18n instance as react-i18next default usage
    .init({
        resources,
        lng: initLang,
        fallbackLng: langTypes.ZH_TW,
        keySeparator: false, // we do not use keys in form messages.welcome
        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

export let i18nLangOfGame = null;

if (IS_EDITOR_MODE) {
    i18nLangOfGame = i18n.createInstance();
    i18nLangOfGame.use(ICU).init({
        resources: editorTranslation,
        lng: langTypes.ZH_TW,
        fallbackLng: langTypes.ZH_TW,
        keySeparator: false, // we do not use keys in form messages.welcome
        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });
}

export function setI18nLanguage({ lang, editorGameLang } = {}) {
    let promises = [];
    if (lang !== undefined) {
        promises.push(new Promise(res => i18n.changeLanguage(lang, () => res())));
    }
    if (editorGameLang !== undefined && IS_EDITOR_MODE) {
        promises.push(
            new Promise(res => i18nLangOfGame.changeLanguage(editorGameLang, () => res()))
        );
    }
    return Promise.all(promises);
}
